import { render, staticRenderFns } from "./leaveQueue.vue?vue&type=template&id=415493e6&scoped=true&"
import script from "./leaveQueue.vue?vue&type=script&lang=js&"
export * from "./leaveQueue.vue?vue&type=script&lang=js&"
import style0 from "./leaveQueue.vue?vue&type=style&index=0&id=415493e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415493e6",
  null
  
)

export default component.exports